
// ----------------------------------------------------------------------

const organizations = [
  {
    "id": "0",
    "type": "public",
    "name_zh": "Public",
    "name_en": "Public",
    "address_zh": "Public",
    "address_en": "Public",
    "phone": "Public",
    "contact_person": "n/a",
    "contact_phone": "n/a",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 10:17:16",
    "updated_at": "2023-02-22 10:17:16",
    "deleted_at": ""
  },
  {
    "id": "1",
    "type": "school",
    "name_zh": "佛教林金殿小學",
    "name_en": "佛教林金殿小學",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-09 13:26:18",
    "updated_at": "2023-02-09 13:26:18",
    "deleted_at": ""
  },
  {
    "id": "2",
    "type": "school",
    "name_zh": "YC(TSW)",
    "name_en": "YC(TSW)",
    "address_zh": "YC(TSW)",
    "address_en": "YC(TSW)",
    "phone": "99991111",
    "contact_person": "TBC",
    "contact_phone": "91111111",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 09:38:10",
    "updated_at": "2023-03-20 11:09:18",
    "deleted_at": ""
  },
  {
    "id": "4",
    "type": "vtc",
    "name_zh": "IVE03",
    "name_en": "IVE03",
    "address_zh": "IVE03",
    "address_en": "IVE03",
    "phone": "91239123",
    "contact_person": "TBC",
    "contact_phone": "91239123",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 14:45:06",
    "updated_at": "2023-02-22 14:45:06",
    "deleted_at": ""
  },
  {
    "id": "5",
    "type": "vtc",
    "name_zh": "YC (YCM)",
    "name_en": "YC (YCM)",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 14:45:33",
    "updated_at": "2023-03-20 13:14:11",
    "deleted_at": ""
  },
  {
    "id": "6",
    "type": "vtc",
    "name_zh": "IVE05",
    "name_en": "IVE05",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 14:46:06",
    "updated_at": "2023-02-22 14:46:06",
    "deleted_at": ""
  },
  {
    "id": "7",
    "type": "vtc",
    "name_zh": "IVE10",
    "name_en": "IVE10",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 14:46:28",
    "updated_at": "2023-02-22 14:46:28",
    "deleted_at": ""
  },
  {
    "id": "8",
    "type": "edb",
    "name_zh": "EDB",
    "name_en": "EDB",
    "address_zh": "EDB Hong Kong",
    "address_en": "EDB Hong Kong",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-02-22 19:05:17",
    "deleted_at": ""
  },
  {
    "id": "9",
    "type": "primary",
    "name_zh": "慈幼葉漢千禧小學",
    "name_en": "Salesian Yip Hon Millennium Primary School",
    "address_zh": "慈幼葉漢千禧小學",
    "address_en": "慈幼葉漢千禧小學",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-02-22 19:05:17",
    "deleted_at": ""
  },
  {
    "id": "10",
    "type": "primary",
    "name_zh": "保良局陸慶濤小學",
    "name_en": "Po Leung Kuk Luk Hing Too Primary School",
    "address_zh": "保良局陸慶濤小學",
    "address_en": "保良局陸慶濤小學",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-02-22 19:05:17",
    "deleted_at": ""
  },
  {
    "id": "11",
    "type": "primary",
    "name_zh": "可信學校",
    "name_en": "Ho Shun Primary School ",
    "address_zh": "嗇色園主辦可信學校",
    "address_en": "嗇色園主辦可信學校",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "9",
    "login_access_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJvcmdJRCI6IjExIiwiYWRtaW5Vc2VySUQiOiI5IiwicmFuIjoiN2Q5NzE5N2QzMzJiZTJjN2YyMjIifQ.g4jFfaTcDz9DEq97Op_pXyEcvWK1tS691fnFGC5kZoM",
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-12-13 14:06:16",
    "deleted_at": ""
  },
  {
    "id": "12",
    "type": "primary",
    "name_zh": "聖馬善樂小學",
    "name_en": "ST. Eugene de Mazenod Oblate Primary School",
    "address_zh": "聖馬善樂小學",
    "address_en": "聖馬善樂小學",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-02-22 19:05:17",
    "deleted_at": ""
  },
  {
    "id": "13",
    "type": "school",
    "name_zh": "博愛醫院八十週年鄧英喜中學",
    "name_en": "Pok Oi Hospital 80th Anniversary Tang Ying Hei College",
    "address_zh": "博愛醫院八十週年鄧英喜中學",
    "address_en": "博愛醫院八十週年鄧英喜中學",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "10",
    "login_access_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJvcmdJRCI6IjEzIiwiYWRtaW5Vc2VySUQiOiIxMCIsInJhbiI6IjJkNGM5ZTk4YmNkNzVlMGU3ZmI1In0.zfAmHT4bZW6lhZlPV5ehk7mIlPOL679Vuu0LtyO6FvU",
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-12-13 14:33:45",
    "deleted_at": ""
  },
  {
    "id": "14",
    "type": "school",
    "name_zh": "德蘭中學",
    "name_en": "St. Teresa Secondary School",
    "address_zh": "德蘭中學",
    "address_en": "德蘭中學",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-02-22 19:05:17",
    "deleted_at": ""
  },
  {
    "id": "15",
    "type": "school",
    "name_zh": "將軍澳香島中學",
    "name_en": "Heung To Secondary School (Tseung Kwan O) ",
    "address_zh": " 將軍澳香島中學",
    "address_en": " 將軍澳香島中學",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-02-22 19:05:17",
    "deleted_at": ""
  },
  {
    "id": "16",
    "type": "school",
    "name_zh": "英華書院",
    "name_en": "Ying Wa College",
    "address_zh": "英華書院",
    "address_en": "英華書院",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-02-22 19:05:17",
    "deleted_at": ""
  },
  {
    "id": "17",
    "type": "school",
    "name_zh": "東華三院李潤田紀念中學",
    "name_en": "Tung Wah Group of Hospitals Lee Ching Dea Memorial College",
    "address_zh": "東華三院李潤田紀念中學",
    "address_en": "東華三院李潤田紀念中學",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-02-22 19:05:17",
    "deleted_at": ""
  },
  {
    "id": "18",
    "type": "school",
    "name_zh": "五邑司徒浩中學",
    "name_en": "The Districts Business Welfare Association School (FDBWA) Szeto Ho Secondary School",
    "address_zh": "五邑司徒浩中學",
    "address_en": "五邑司徒浩中學",
    "phone": "99998888",
    "contact_person": "TBC",
    "contact_phone": "99998888",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-02-22 19:05:17",
    "updated_at": "2023-02-22 19:05:17",
    "deleted_at": ""
  },
  {
    "id": "19",
    "type": "school",
    "name_zh": "長沙灣天主教英文中學",
    "name_en": "Cheung Sha Wan Catholic Secondary School ",
    "address_zh": "長沙灣天主教英文中學",
    "address_en": "長沙灣天主教英文中學",
    "phone": "90000000",
    "contact_person": "TBC",
    "contact_phone": "90000000",
    "admin_user_id": "7",
    "login_access_token": null,
    "created_at": "2023-03-02 09:55:17",
    "updated_at": "2023-12-04 17:31:09",
    "deleted_at": ""
  },
  {
    "id": "20",
    "type": "school",
    "name_zh": "余振強紀念第二中學",
    "name_en": "Yu Chun Keung Memorial College No.2",
    "address_zh": "余振強紀念第二中學",
    "address_en": "余振強紀念第二中學",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-02 09:55:48",
    "updated_at": "2023-03-02 09:55:48",
    "deleted_at": ""
  },
  {
    "id": "21",
    "type": "school",
    "name_zh": "高主教書院",
    "name_en": "Raimondi College",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:34:21",
    "updated_at": "2023-03-05 23:34:21",
    "deleted_at": ""
  },
  {
    "id": "22",
    "type": "school",
    "name_zh": "聖伯多祿中學",
    "name_en": "St. Peter's Secondary School ",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:34:29",
    "updated_at": "2023-03-05 23:34:29",
    "deleted_at": ""
  },
  {
    "id": "24",
    "type": "school",
    "name_zh": "聖貞德中學",
    "name_en": "St. Joan of Arc Secondary School, Hong Kong",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:34:43",
    "updated_at": "2023-03-05 23:34:43",
    "deleted_at": ""
  },
  {
    "id": "25",
    "type": "school",
    "name_zh": "荔景天主教中學",
    "name_en": "Lai King Catholic Secondary School",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:34:51",
    "updated_at": "2023-03-05 23:34:51",
    "deleted_at": ""
  },
  {
    "id": "26",
    "type": "school",
    "name_zh": "觀塘瑪利諾書院",
    "name_en": "Kwun Tong Maryknoll College",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:34:56",
    "updated_at": "2023-03-05 23:34:56",
    "deleted_at": ""
  },
  {
    "id": "27",
    "type": "school",
    "name_zh": "梁式芝書院",
    "name_en": "Leung Shek Chee College（Sau Mau Ping）",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:35:03",
    "updated_at": "2023-03-05 23:35:03",
    "deleted_at": ""
  },
  {
    "id": "28",
    "type": "school",
    "name_zh": "順利天主教中學",
    "name_en": "Shun Lee Catholic Secondary School ",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:35:10",
    "updated_at": "2023-03-05 23:35:10",
    "deleted_at": ""
  },
  {
    "id": "29",
    "type": "school",
    "name_zh": "聖若瑟英文中學",
    "name_en": "St. Joseph's Anglo-Chinese School",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:35:15",
    "updated_at": "2023-03-05 23:35:15",
    "deleted_at": ""
  },
  {
    "id": "30",
    "type": "school",
    "name_zh": "彩虹邨天主教英文中學",
    "name_en": "Choi Hung Estate Catholic Secondary School ",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:35:21",
    "updated_at": "2023-03-05 23:35:21",
    "deleted_at": ""
  },
  {
    "id": "31",
    "type": "school",
    "name_zh": "天主教南華中學",
    "name_en": "Nam Wah Catholic Secondary School ",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:35:26",
    "updated_at": "2023-03-05 23:35:26",
    "deleted_at": ""
  },
  {
    "id": "32",
    "type": "school",
    "name_zh": "天主教伍華中學",
    "name_en": "Ng Wah Catholic Secondary School ",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:35:33",
    "updated_at": "2023-03-05 23:35:33",
    "deleted_at": ""
  },
  {
    "id": "34",
    "type": "school",
    "name_zh": "西貢崇真天主教學校(中學部)",
    "name_en": "Sung Tsun Catholic School",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:35:44",
    "updated_at": "2023-03-05 23:35:44",
    "deleted_at": ""
  },
  {
    "id": "35",
    "type": "school",
    "name_zh": "屯門天主教中學",
    "name_en": "Tuen Mun Catholic Secondary School",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:35:56",
    "updated_at": "2023-03-05 23:35:56",
    "deleted_at": ""
  },
  {
    "id": "36",
    "type": "school",
    "name_zh": "天主教新民書院",
    "name_en": "Newman Catholic College",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:01",
    "updated_at": "2023-03-05 23:36:01",
    "deleted_at": ""
  },
  {
    "id": "37",
    "type": "school",
    "name_zh": "石籬天主教中學",
    "name_en": "Shek Lei Catholic Secondary School",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:07",
    "updated_at": "2023-03-05 23:36:07",
    "deleted_at": ""
  },
  {
    "id": "38",
    "type": "school",
    "name_zh": "天主教郭得勝中學",
    "name_en": "Kwok Tak Seng Catholic Secondary School",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:13",
    "updated_at": "2023-03-05 23:36:13",
    "deleted_at": ""
  },
  {
    "id": "39",
    "type": "school",
    "name_zh": "天主教培聖中學",
    "name_en": "Pui Shing Catholic Secondary School",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:18",
    "updated_at": "2023-03-05 23:36:18",
    "deleted_at": ""
  },
  {
    "id": "40",
    "type": "school",
    "name_zh": "元朗天主教中學",
    "name_en": "Yuen Long Catholic Secondary School",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:24",
    "updated_at": "2023-03-05 23:36:24",
    "deleted_at": ""
  },
  {
    "id": "41",
    "type": "school",
    "name_zh": "聖芳濟各書院",
    "name_en": "Saint Francis of Assisi's College",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:29",
    "updated_at": "2023-03-05 23:36:29",
    "deleted_at": ""
  },
  {
    "id": "42",
    "type": "school",
    "name_zh": "恩主教書院",
    "name_en": "Valtorta College",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:35",
    "updated_at": "2023-03-05 23:36:35",
    "deleted_at": ""
  },
  {
    "id": "43",
    "type": "school",
    "name_zh": "德蘭中學",
    "name_en": "St. Teresa Secondary School",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:40",
    "updated_at": "2023-03-05 23:36:40",
    "deleted_at": ""
  },
  {
    "id": "44",
    "type": "school",
    "name_zh": "余振強紀念中學",
    "name_en": "Yu Chun Keung Memorial College",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:46",
    "updated_at": "2023-03-05 23:36:46",
    "deleted_at": ""
  },
  {
    "id": "45",
    "type": "school",
    "name_zh": "東涌天主教學校",
    "name_en": "Tung Chung Catholic School Secondary Section",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:51",
    "updated_at": "2023-03-05 23:36:51",
    "deleted_at": ""
  },
  {
    "id": "46",
    "type": "school",
    "name_zh": "聖安當女書院",
    "name_en": "Saint Antonius Girls' College",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:36:57",
    "updated_at": "2023-03-05 23:36:57",
    "deleted_at": ""
  },
  {
    "id": "47",
    "type": "school",
    "name_zh": "天主教崇德英文書院",
    "name_en": "Shung Tak Catholic English College",
    "address_zh": "TBC",
    "address_en": "TBC",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-05 23:37:03",
    "updated_at": "2023-03-05 23:37:03",
    "deleted_at": ""
  },
  {
    "id": "48",
    "type": "school",
    "name_zh": "筲箕灣東官立中學",
    "name_en": "筲箕灣東官立中學",
    "address_zh": "筲箕灣東官立中學",
    "address_en": "筲箕灣東官立中學",
    "phone": "99999999",
    "contact_person": "TBC",
    "contact_phone": "99999999",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 10:03:23",
    "updated_at": "2023-03-20 10:03:23",
    "deleted_at": ""
  },
  {
    "id": "49",
    "type": "school",
    "name_zh": "聖公會李福慶中學",
    "name_en": "聖公會李福慶中學",
    "address_zh": "聖公會李福慶中學",
    "address_en": "聖公會李福慶中學",
    "phone": "00000000",
    "contact_person": "TBC",
    "contact_phone": "00000000",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 10:09:19",
    "updated_at": "2023-03-20 10:09:19",
    "deleted_at": ""
  },
  {
    "id": "50",
    "type": "school",
    "name_zh": "嶺南中學",
    "name_en": "Lingnan Secondary School",
    "address_zh": "Lingnan Secondary School",
    "address_en": "Lingnan Secondary School",
    "phone": "00000000",
    "contact_person": "TBC",
    "contact_phone": "00000000",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 10:11:05",
    "updated_at": "2023-03-20 10:11:05",
    "deleted_at": ""
  },
  {
    "id": "51",
    "type": "school",
    "name_zh": "寶血女子中學",
    "name_en": "Precious Blood Secondary School",
    "address_zh": "Precious Blood Secondary School",
    "address_en": "Precious Blood Secondary School",
    "phone": "00000000",
    "contact_person": "TBC",
    "contact_phone": "00000000",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 10:11:52",
    "updated_at": "2023-03-20 10:11:52",
    "deleted_at": ""
  },
  {
    "id": "52",
    "type": "school",
    "name_zh": "新會商會陳白沙紀念中學",
    "name_en": "San Wui Commercial Soc Chan Pak Sha School",
    "address_zh": "San Wui Commercial Soc Chan Pak Sha School",
    "address_en": "San Wui Commercial Soc Chan Pak Sha School",
    "phone": "00000000",
    "contact_person": "tbc",
    "contact_phone": "00000000",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 10:15:45",
    "updated_at": "2023-03-20 10:15:45",
    "deleted_at": ""
  },
  {
    "id": "53",
    "type": "school",
    "name_zh": "孔聖堂中學",
    "name_en": "Confucius Hall Secondary School",
    "address_zh": "Confucius Hall Secondary School",
    "address_en": "Confucius Hall Secondary School",
    "phone": "00000000",
    "contact_person": "tbc",
    "contact_phone": "00000000",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 10:19:19",
    "updated_at": "2023-03-20 10:19:19",
    "deleted_at": ""
  },
  {
    "id": "54",
    "type": "vtc",
    "name_zh": "YC(YCM)",
    "name_en": "YC(YCM)",
    "address_zh": "YC (YCM)",
    "address_en": "YC (YCM)",
    "phone": "25952608",
    "contact_person": "YC (YCM)",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 11:10:12",
    "updated_at": "2023-03-20 11:12:18",
    "deleted_at": ""
  },
  {
    "id": "55",
    "type": "vtc",
    "name_zh": "YC(TM)",
    "name_en": "YC(TM)",
    "address_zh": "YC(TM)",
    "address_en": "YC(TM)",
    "phone": "25952608",
    "contact_person": "YC(TM)",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 11:10:57",
    "updated_at": "2023-03-20 11:10:57",
    "deleted_at": ""
  },
  {
    "id": "56",
    "type": "vtc",
    "name_zh": "IVE(CW)",
    "name_en": "IVE(CW)",
    "address_zh": "IVE(CW)",
    "address_en": "IVE(CW)",
    "phone": "25952608",
    "contact_person": "25952608",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 11:11:29",
    "updated_at": "2023-05-09 11:52:34",
    "deleted_at": ""
  },
  {
    "id": "57",
    "type": "vtc",
    "name_zh": "IVE(HW)",
    "name_en": "IVE(HW)",
    "address_zh": "IVE(HW)",
    "address_en": "IVE(HW)",
    "phone": "25952608",
    "contact_person": "25952608",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 11:11:57",
    "updated_at": "2023-05-09 11:53:16",
    "deleted_at": ""
  },
  {
    "id": "59",
    "type": "vtc",
    "name_zh": "ICI",
    "name_en": "ICI",
    "address_zh": "ICI",
    "address_en": "ICI",
    "phone": "25952608",
    "contact_person": "25952608",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-03-20 11:14:12",
    "updated_at": "2023-03-20 13:59:09",
    "deleted_at": ""
  },
  {
    "id": "60",
    "type": "school",
    "name_zh": "獅子會中學",
    "name_en": "Lions College",
    "address_zh": "葵芳",
    "address_en": "葵芳",
    "phone": "26147938",
    "contact_person": "SHE",
    "contact_phone": "26147938",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-04-13 13:55:08",
    "updated_at": "2023-04-13 13:55:08",
    "deleted_at": ""
  },
  {
    "id": "61",
    "type": "edb",
    "name_zh": "VTC@Lok Fu Place",
    "name_en": "VTC@Lok Fu Place",
    "address_zh": "Lok Fu",
    "address_en": "Lok Fu",
    "phone": "25952608",
    "contact_person": "Ngo",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-04-22 09:32:26",
    "updated_at": "2023-04-22 10:20:52",
    "deleted_at": ""
  },
  {
    "id": "62",
    "type": "school",
    "name_zh": "慈幼英文中學",
    "name_en": "Salesian English School",
    "address_zh": "筲箕灣",
    "address_en": "Sui Kei Wan",
    "phone": "25952608",
    "contact_person": "Leung Sir",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-05-03 11:36:13",
    "updated_at": "2023-05-03 11:36:13",
    "deleted_at": ""
  },
  {
    "id": "63",
    "type": "school",
    "name_zh": "新生命教育協會平安福音中學",
    "name_en": "NLSI Peace Evangelical Secondary School",
    "address_zh": "屯門",
    "address_en": "Tuen Mun",
    "phone": "25952608",
    "contact_person": "Wil",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-05-03 14:23:04",
    "updated_at": "2023-05-03 14:23:04",
    "deleted_at": ""
  },
  {
    "id": "64",
    "type": "vtc",
    "name_zh": "GBA",
    "name_en": "GBA",
    "address_zh": "GBA",
    "address_en": "GBA",
    "phone": "25952608",
    "contact_person": "Lo",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-05-16 11:12:28",
    "updated_at": "2023-05-16 11:12:28",
    "deleted_at": ""
  },
  {
    "id": "65",
    "type": "company",
    "name_zh": "Mosaic Digital",
    "name_en": "Mosaic Digital",
    "address_zh": "Mosaic Digital",
    "address_en": "Mosaic Digital",
    "phone": "91239123",
    "contact_person": "ken",
    "contact_phone": "91239123",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-05-16 16:29:23",
    "updated_at": "2023-05-16 16:29:23",
    "deleted_at": ""
  },
  {
    "id": "66",
    "type": "school",
    "name_zh": "基督教聖約教會堅樂中學",
    "name_en": "基督教聖約教會堅樂中學",
    "address_zh": "觀塘曉明街",
    "address_en": "觀塘曉明街",
    "phone": "25952608",
    "contact_person": "Miss",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-07 11:29:40",
    "updated_at": "2023-06-07 11:29:40",
    "deleted_at": ""
  },
  {
    "id": "67",
    "type": "vtc",
    "name_zh": "HT Engagement",
    "name_en": "HT Engagement",
    "address_zh": "ICI",
    "address_en": "ICI",
    "phone": "25952608",
    "contact_person": "WL",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-14 11:49:12",
    "updated_at": "2023-06-14 11:49:12",
    "deleted_at": ""
  },
  {
    "id": "68",
    "type": "primary",
    "name_zh": "合一堂學校",
    "name_en": "合一堂學校",
    "address_zh": "九龍何文田公主道7號",
    "address_en": "九龍何文田公主道7號",
    "phone": "25952608",
    "contact_person": "Mr Hui",
    "contact_phone": "25952608",
    "admin_user_id": "8",
    "login_access_token": null,
    "created_at": "2023-06-27 15:58:58",
    "updated_at": "2023-12-04 17:36:23",
    "deleted_at": ""
  },
  {
    "id": "69",
    "type": "school",
    "name_zh": "可立中學（嗇色園主辦）",
    "name_en": "可立中學（嗇色園主辦）",
    "address_zh": "可立中學（嗇色園主辦）",
    "address_en": "可立中學（嗇色園主辦）",
    "phone": "25952608",
    "contact_person": "SHE",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:04:29",
    "updated_at": "2023-06-29 16:04:29",
    "deleted_at": ""
  },
  {
    "id": "70",
    "type": "school",
    "name_zh": "慈航學校",
    "name_en": "慈航學校",
    "address_zh": "慈航學校",
    "address_en": "慈航學校",
    "phone": "25952608",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "03312356",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:05:12",
    "updated_at": "2023-06-29 16:05:12",
    "deleted_at": ""
  },
  {
    "id": "71",
    "type": "school",
    "name_zh": "聖母無玷聖心書院",
    "name_en": "聖母無玷聖心書院",
    "address_zh": "聖母無玷聖心書院",
    "address_en": "聖母無玷聖心書院",
    "phone": "43546758",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "43546758",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:05:34",
    "updated_at": "2023-06-29 16:05:34",
    "deleted_at": ""
  },
  {
    "id": "72",
    "type": "school",
    "name_zh": "浸信會呂明才中學",
    "name_en": "浸信會呂明才中學",
    "address_zh": "浸信會呂明才中學",
    "address_en": "浸信會呂明才中學",
    "phone": "13214235",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "21313156",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:05:57",
    "updated_at": "2023-06-29 16:05:57",
    "deleted_at": ""
  },
  {
    "id": "73",
    "type": "school",
    "name_zh": "香港華仁書院",
    "name_en": "香港華仁書院",
    "address_zh": "香港華仁書院",
    "address_en": "香港華仁書院",
    "phone": "12425467",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "42142356",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:06:16",
    "updated_at": "2023-06-29 16:06:16",
    "deleted_at": ""
  },
  {
    "id": "74",
    "type": "school",
    "name_zh": "香海正覺蓮社佛教陳式宏學校",
    "name_en": "香海正覺蓮社佛教陳式宏學校",
    "address_zh": "香海正覺蓮社佛教陳式宏學校",
    "address_en": "香海正覺蓮社佛教陳式宏學校",
    "phone": "12321578",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "21423578",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:06:34",
    "updated_at": "2023-06-29 16:06:34",
    "deleted_at": ""
  },
  {
    "id": "75",
    "type": "school",
    "name_zh": "東莞同鄉會方樹泉學校",
    "name_en": "東莞同鄉會方樹泉學校",
    "address_zh": "東莞同鄉會方樹泉學校",
    "address_en": "Kwai Chung",
    "phone": "31242679",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31246458",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:06:57",
    "updated_at": "2023-06-29 16:06:57",
    "deleted_at": ""
  },
  {
    "id": "76",
    "type": "school",
    "name_zh": "油蔴地街坊會學校",
    "name_en": "油蔴地街坊會學校",
    "address_zh": "油蔴地街坊會學校",
    "address_en": "油蔴地街坊會學校",
    "phone": "21432540",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31243680",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:07:20",
    "updated_at": "2023-06-29 16:07:20",
    "deleted_at": ""
  },
  {
    "id": "77",
    "type": "primary",
    "name_zh": "聖公會置富始南小學",
    "name_en": "聖公會置富始南小學",
    "address_zh": "聖公會置富始南小學",
    "address_en": "聖公會置富始南小學",
    "phone": "12312421",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31232145",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:07:46",
    "updated_at": "2023-06-29 16:07:46",
    "deleted_at": ""
  },
  {
    "id": "78",
    "type": "school",
    "name_zh": "保良局姚連生中學",
    "name_en": "保良局姚連生中學",
    "address_zh": "保良局姚連生中學",
    "address_en": "保良局姚連生中學",
    "phone": "21432167",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "12344678",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:08:07",
    "updated_at": "2023-06-29 16:08:07",
    "deleted_at": ""
  },
  {
    "id": "79",
    "type": "school",
    "name_zh": "聖公會曾肇添中學",
    "name_en": "聖公會曾肇添中學",
    "address_zh": "聖公會曾肇添中學",
    "address_en": "聖公會曾肇添中學",
    "phone": "32142567",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "21412678",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:08:26",
    "updated_at": "2023-06-29 16:08:26",
    "deleted_at": ""
  },
  {
    "id": "80",
    "type": "school",
    "name_zh": "嘉諾撒聖心書院",
    "name_en": "嘉諾撒聖心書院",
    "address_zh": "嘉諾撒聖心書院",
    "address_en": "嘉諾撒聖心書院",
    "phone": "32131245",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "12312556",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:08:50",
    "updated_at": "2023-06-29 16:08:50",
    "deleted_at": ""
  },
  {
    "id": "81",
    "type": "primary",
    "name_zh": "沙田循道衛理小學",
    "name_en": "沙田循道衛理小學",
    "address_zh": "沙田循道衛理小學",
    "address_en": "沙田循道衛理小學",
    "phone": "31231245",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31231256",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:09:15",
    "updated_at": "2023-06-29 16:09:15",
    "deleted_at": ""
  },
  {
    "id": "82",
    "type": "school",
    "name_zh": "中華基督教會扶輪中學",
    "name_en": "中華基督教會扶輪中學",
    "address_zh": "中華基督教會扶輪中學",
    "address_en": "中華基督教會扶輪中學",
    "phone": "21312668",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "12325464",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:09:35",
    "updated_at": "2023-06-29 16:09:35",
    "deleted_at": ""
  },
  {
    "id": "83",
    "type": "school",
    "name_zh": "香港中國婦女會馮堯敬紀念中學",
    "name_en": "香港中國婦女會馮堯敬紀念中學",
    "address_zh": "香港中國婦女會馮堯敬紀念中學",
    "address_en": "香港中國婦女會馮堯敬紀念中學",
    "phone": "12214124",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "22446580",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:09:56",
    "updated_at": "2023-06-29 16:09:56",
    "deleted_at": ""
  },
  {
    "id": "84",
    "type": "school",
    "name_zh": "筲箕灣崇真學校",
    "name_en": "筲箕灣崇真學校",
    "address_zh": "筲箕灣崇真學校",
    "address_en": "筲箕灣崇真學校",
    "phone": "32143254",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "22145689",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:10:16",
    "updated_at": "2023-06-29 16:10:16",
    "deleted_at": ""
  },
  {
    "id": "85",
    "type": "primary",
    "name_zh": "循理會白普理基金循理小學",
    "name_en": "循理會白普理基金循理小學",
    "address_zh": "循理會白普理基金循理小學",
    "address_en": "循理會白普理基金循理小學",
    "phone": "31242146",
    "contact_person": "循理會白普理基金循理小學",
    "contact_phone": "12312425",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:10:36",
    "updated_at": "2023-06-29 16:10:36",
    "deleted_at": ""
  },
  {
    "id": "86",
    "type": "school",
    "name_zh": "聖士提反女子中學",
    "name_en": "聖士提反女子中學",
    "address_zh": "聖士提反女子中學",
    "address_en": "聖士提反女子中學",
    "phone": "21421468",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31231456",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:10:59",
    "updated_at": "2023-06-29 16:10:59",
    "deleted_at": ""
  },
  {
    "id": "87",
    "type": "school",
    "name_zh": "香港仔浸信會呂明才書院",
    "name_en": "香港仔浸信會呂明才書院",
    "address_zh": "香港仔浸信會呂明才書院",
    "address_en": "香港仔浸信會呂明才書院",
    "phone": "21321321",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "12321467",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:11:21",
    "updated_at": "2023-06-29 16:11:21",
    "deleted_at": ""
  },
  {
    "id": "88",
    "type": "school",
    "name_zh": "台山商會中學",
    "name_en": "台山商會中學",
    "address_zh": "台山商會中學",
    "address_en": "台山商會中學",
    "phone": "32131242",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31231255",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:11:38",
    "updated_at": "2023-06-29 16:11:38",
    "deleted_at": ""
  },
  {
    "id": "89",
    "type": "school",
    "name_zh": "鄧肇堅維多利亞官立中學",
    "name_en": "鄧肇堅維多利亞官立中學",
    "address_zh": "鄧肇堅維多利亞官立中學",
    "address_en": "鄧肇堅維多利亞官立中學",
    "phone": "12321421",
    "contact_person": "鄧肇堅維多利亞官立中學",
    "contact_phone": "21412412",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:12:00",
    "updated_at": "2023-06-29 16:12:00",
    "deleted_at": ""
  },
  {
    "id": "90",
    "type": "school",
    "name_zh": "順德聯誼總會譚伯羽中學",
    "name_en": "順德聯誼總會譚伯羽中學",
    "address_zh": "順德聯誼總會譚伯羽中學",
    "address_en": "順德聯誼總會譚伯羽中學",
    "phone": "31224556",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "12321456",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:12:25",
    "updated_at": "2023-06-29 16:12:25",
    "deleted_at": ""
  },
  {
    "id": "91",
    "type": "school",
    "name_zh": "寧波公學",
    "name_en": "寧波公學",
    "address_zh": "寧波公學",
    "address_en": "寧波公學",
    "phone": "12321567",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "13124566",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:12:41",
    "updated_at": "2023-06-29 16:12:41",
    "deleted_at": ""
  },
  {
    "id": "92",
    "type": "school",
    "name_zh": "香港兆基創意書院",
    "name_en": "香港兆基創意書院",
    "address_zh": "香港兆基創意書院",
    "address_en": "香港兆基創意書院",
    "phone": "31233215",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "12454657",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:12:59",
    "updated_at": "2023-06-29 16:12:59",
    "deleted_at": ""
  },
  {
    "id": "93",
    "type": "school",
    "name_zh": "聖公會白約翰會督中學",
    "name_en": "聖公會白約翰會督中學",
    "address_zh": "聖公會白約翰會督中學",
    "address_en": "聖公會白約翰會督中學",
    "phone": "12321312",
    "contact_person": "聖公會白約翰會督中學",
    "contact_phone": "21341245",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:13:18",
    "updated_at": "2023-06-29 16:13:18",
    "deleted_at": ""
  },
  {
    "id": "94",
    "type": "school",
    "name_zh": "東華三院鄺錫坤伉儷中學",
    "name_en": "東華三院鄺錫坤伉儷中學",
    "address_zh": "東華三院鄺錫坤伉儷中學",
    "address_en": "東華三院鄺錫坤伉儷中學",
    "phone": "31231456",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31424564",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:13:39",
    "updated_at": "2023-06-29 16:13:39",
    "deleted_at": ""
  },
  {
    "id": "95",
    "type": "school",
    "name_zh": "東華三院鄺錫坤伉儷中學",
    "name_en": "東華三院鄺錫坤伉儷中學",
    "address_zh": "東華三院鄺錫坤伉儷中學",
    "address_en": "東華三院鄺錫坤伉儷中學",
    "phone": "31231456",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31424564",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:13:40",
    "updated_at": "2023-06-29 16:13:40",
    "deleted_at": ""
  },
  {
    "id": "96",
    "type": "school",
    "name_zh": "新生命教育協會平安福音中學",
    "name_en": "新生命教育協會平安福音中學",
    "address_zh": "新生命教育協會平安福音中學",
    "address_en": "新生命教育協會平安福音中學",
    "phone": "23124312",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31321425",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:13:57",
    "updated_at": "2023-06-29 16:13:57",
    "deleted_at": ""
  },
  {
    "id": "97",
    "type": "school",
    "name_zh": "威靈頓教育機構張沛松紀念中學",
    "name_en": "威靈頓教育機構張沛松紀念中學",
    "address_zh": "威靈頓教育機構張沛松紀念中學",
    "address_en": "威靈頓教育機構張沛松紀念中學",
    "phone": "31312356",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31231256",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:14:15",
    "updated_at": "2023-06-29 16:14:15",
    "deleted_at": ""
  },
  {
    "id": "98",
    "type": "primary",
    "name_zh": "浸信會呂明才小學",
    "name_en": "浸信會呂明才小學",
    "address_zh": "浸信會呂明才小學",
    "address_en": "浸信會呂明才小學",
    "phone": "21314567",
    "contact_person": "浸信會呂明才小學",
    "contact_phone": "23124215",
    "admin_user_id": "11",
    "login_access_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJvcmdJRCI6Ijk4IiwiYWRtaW5Vc2VySUQiOiIxMSIsInJhbiI6IjI2MTA1MjdmODU5YjQ1NWVmOWQ2In0.PR1xodzMlXUNmTPvoZL2S7iH8KQiBuSca4W5kYJIgho",
    "created_at": "2023-06-29 16:14:35",
    "updated_at": "2024-02-02 14:21:11",
    "deleted_at": ""
  },
  {
    "id": "99",
    "type": "school",
    "name_zh": "聖母玫瑰書院",
    "name_en": "聖母玫瑰書院",
    "address_zh": "聖母玫瑰書院",
    "address_en": "Kwai Chung",
    "phone": "23112456",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "12312423",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:16:53",
    "updated_at": "2023-06-29 16:16:53",
    "deleted_at": ""
  },
  {
    "id": "100",
    "type": "ngo",
    "name_zh": "中華基督教會燕京書院",
    "name_en": "中華基督教會燕京書院",
    "address_zh": "中華基督教會燕京書院",
    "address_en": "中華基督教會燕京書院",
    "phone": "31232132",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "12323556",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:17:19",
    "updated_at": "2023-06-29 16:17:19",
    "deleted_at": ""
  },
  {
    "id": "101",
    "type": "school",
    "name_zh": "聖公會莫壽增會督中學",
    "name_en": "聖公會莫壽增會督中學",
    "address_zh": "聖公會莫壽增會督中學",
    "address_en": "聖公會莫壽增會督中學",
    "phone": "21312434",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "12321423",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:39:48",
    "updated_at": "2023-06-29 16:39:48",
    "deleted_at": ""
  },
  {
    "id": "102",
    "type": "school",
    "name_zh": "粉嶺官立中學",
    "name_en": "粉嶺官立中學",
    "address_zh": "粉嶺官立中學",
    "address_en": "Kwai Chung",
    "phone": "32312467",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "31242314",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:40:14",
    "updated_at": "2023-06-29 16:40:14",
    "deleted_at": ""
  },
  {
    "id": "103",
    "type": "school",
    "name_zh": "港澳信義會慕德中學",
    "name_en": "港澳信義會慕德中學",
    "address_zh": "港澳信義會慕德中學",
    "address_en": "港澳信義會慕德中學",
    "phone": "32131242",
    "contact_person": "港澳信義會慕德中學",
    "contact_phone": "32312456",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:40:34",
    "updated_at": "2023-06-29 16:40:34",
    "deleted_at": ""
  },
  {
    "id": "104",
    "type": "primary",
    "name_zh": "油蔴地天主教小學",
    "name_en": "油蔴地天主教小學",
    "address_zh": "油蔴地天主教小學",
    "address_en": "油蔴地天主教小學",
    "phone": "23124321",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:40:55",
    "updated_at": "2023-06-29 16:40:55",
    "deleted_at": ""
  },
  {
    "id": "105",
    "type": "school",
    "name_zh": "聖公會梁季彜中學",
    "name_en": "聖公會梁季彜中學",
    "address_zh": "聖公會梁季彜中學",
    "address_en": "聖公會梁季彜中學",
    "phone": "25952608",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:41:16",
    "updated_at": "2023-06-29 16:41:16",
    "deleted_at": ""
  },
  {
    "id": "106",
    "type": "school",
    "name_zh": "聖公會李炳中學",
    "name_en": "聖公會李炳中學",
    "address_zh": "聖公會李炳中學",
    "address_en": "聖公會李炳中學",
    "phone": "25952608",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:41:33",
    "updated_at": "2023-06-29 16:41:33",
    "deleted_at": ""
  },
  {
    "id": "107",
    "type": "school",
    "name_zh": "鳳溪廖潤琛紀念學校",
    "name_en": "鳳溪廖潤琛紀念學校",
    "address_zh": "鳳溪廖潤琛紀念學校",
    "address_en": "鳳溪廖潤琛紀念學校",
    "phone": "25952608",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:41:53",
    "updated_at": "2023-06-29 16:41:53",
    "deleted_at": ""
  },
  {
    "id": "108",
    "type": "primary",
    "name_zh": "梨木樹天主教小學",
    "name_en": "梨木樹天主教小學",
    "address_zh": "梨木樹天主教小學",
    "address_en": "Kwai Chung",
    "phone": "12312456",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:42:33",
    "updated_at": "2023-06-29 16:42:33",
    "deleted_at": ""
  },
  {
    "id": "109",
    "type": "school",
    "name_zh": "迦密主恩中學",
    "name_en": "迦密主恩中學",
    "address_zh": "迦密主恩中學",
    "address_en": "迦密主恩中學",
    "phone": "25952608",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:42:48",
    "updated_at": "2023-06-29 16:42:48",
    "deleted_at": ""
  },
  {
    "id": "110",
    "type": "school",
    "name_zh": "官立嘉道理爵士中學（西九龍）",
    "name_en": "官立嘉道理爵士中學（西九龍）",
    "address_zh": "官立嘉道理爵士中學（西九龍）",
    "address_en": "官立嘉道理爵士中學（西九龍）",
    "phone": "25952608",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:43:07",
    "updated_at": "2023-06-29 16:43:07",
    "deleted_at": ""
  },
  {
    "id": "111",
    "type": "school",
    "name_zh": "將軍澳官立中學",
    "name_en": "將軍澳官立中學",
    "address_zh": "將軍澳官立中學",
    "address_en": "將軍澳官立中學",
    "phone": "25952608",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:43:26",
    "updated_at": "2023-06-29 16:43:26",
    "deleted_at": ""
  },
  {
    "id": "112",
    "type": "primary",
    "name_zh": "基督教培恩小學",
    "name_en": "基督教培恩小學",
    "address_zh": "基督教培恩小學",
    "address_en": "基督教培恩小學",
    "phone": "25952608",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:43:45",
    "updated_at": "2023-06-29 16:43:45",
    "deleted_at": ""
  },
  {
    "id": "113",
    "type": "school",
    "name_zh": "觀塘功樂官立中學",
    "name_en": "觀塘功樂官立中學",
    "address_zh": "觀塘功樂官立中學",
    "address_en": "觀塘功樂官立中學",
    "phone": "25952608",
    "contact_person": "Lo Hon Keung",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-06-29 16:44:18",
    "updated_at": "2023-06-29 16:44:18",
    "deleted_at": ""
  },
  {
    "id": "114",
    "type": "vtc",
    "name_zh": "香港賽馬會",
    "name_en": "HKJC",
    "address_zh": "沙田馬場",
    "address_en": "Sha Tin Racecourse",
    "phone": "25950608",
    "contact_person": "Sam",
    "contact_phone": "25952608",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-08-07 14:44:21",
    "updated_at": "2023-10-26 17:28:16",
    "deleted_at": ""
  },
  {
    "id": "116",
    "type": "school",
    "name_zh": "彩虹天主教中學",
    "name_en": "彩虹天主教中學",
    "address_zh": "Hsnnd",
    "address_en": "Hehje",
    "phone": "62782578",
    "contact_person": "Wilson",
    "contact_phone": "62782578",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-11-29 11:01:46",
    "updated_at": "2023-11-29 11:01:46",
    "deleted_at": ""
  },
  {
    "id": "117",
    "type": "school",
    "name_zh": "天主教喇沙會張振興伉儷書院",
    "name_en": "天主教喇沙會張振興伉儷書院",
    "address_zh": "柴灣",
    "address_en": "柴灣",
    "phone": "62782578",
    "contact_person": "62782578",
    "contact_phone": "62782578",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-11-30 17:20:22",
    "updated_at": "2023-11-30 17:20:22",
    "deleted_at": ""
  },
  {
    "id": "118",
    "type": "school",
    "name_zh": "中華基督教會基協中學",
    "name_en": "中華基督教會基協中學",
    "address_zh": "黃大仙",
    "address_en": "黃大仙",
    "phone": "62782578",
    "contact_person": "Wil",
    "contact_phone": "62782578",
    "admin_user_id": "0",
    "login_access_token": null,
    "created_at": "2023-12-13 09:12:18",
    "updated_at": "2023-12-13 09:12:18",
    "deleted_at": ""
  },
  {
    "id": "119",
    "type": "kindergarten",
    "name_zh": "救世軍梨木樹幼兒學校",
    "name_en": "救世軍梨木樹幼兒學校",
    "address_zh": "救世軍梨木樹幼兒學校",
    "address_en": "救世軍梨木樹幼兒學校",
    "phone": "91239000",
    "contact_person": "救世軍梨木樹幼兒學校",
    "contact_phone": "91239000",
    "admin_user_id": "0",
    "login_access_token": "",
    "created_at": "2024-01-23 17:09:46",
    "updated_at": "2024-01-23 17:09:46",
    "deleted_at": ""
  }
];

export default organizations;
